<template>
  <div class="flex items-center">
      <input
        class="w-4 h-4 text-primary accent-primary bg-gray-200 border-gray-300 rounded"
        type="checkbox"
        :name="name"
        :id="name"
        :checked="value"
        v-validate="{'required': shouldValidate}"
        @change="$emit('input', $event.target.checked)"
      />
     <label :for="name" v-html="$t(label)" class="text-sm ms-2" :class="{ 'form-danger': error }"></label>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  inheritAttrs: false,
  props: {
    label: {
      required: true,
      Type: String
    },
    value: {
      required: true
    },
    name: {
      required: true,
      Type: String
    },
    shouldValidate:{},
    error: {
      type: String,
      default: null
    },
    textSmall: {
      required: false,
      type: Boolean,
      default: false
    }
  }
}
</script>
